import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ComponentAnalysisLayer from "../components/ComponentAnalysisLayer";

const ComponentAnalysisPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Component Analysis">
        <ComponentAnalysisLayer />
      </MasterLayout>
    </>
  );
};

export default ComponentAnalysisPage;
